// Override Settings
var bcSfFilterSettings = {
    general: {
        limit: bcSfFilterConfig.custom.products_per_page,
        // Optional
        loadProductFirst: false,
    },
    selector: {
        products: '#product-loop'
    }
};

var bcSfFilterTemplate = {
    'saleLabelHtml': '<div class="collection-label sale-label"><span>SALE</span></div>',
    //'soldOutLabelHtml': '<div class="so icn">' + bcSfFilterConfig.label.sold_out + '</div>',
    'soldOutLabelHtml': '<div class="so icn">SOLD OUT</div>',
    'comingSoonLabelHtml': '<div class="so icn coming-soon">COMING SOON</div>',
    'newLabelHtml': '<div class="collection-label new-label"><span>NEW</span></div>',
  	'bestLabelHtml': '<div class="best_seller icn"><img src="https://cdn.shopify.com/s/files/1/0039/8491/6589/files/new_best1.svg?51118"></div>',
    'toppickLabelHtml': '<div class="top_pick icn"><img src="https://cdn.shopify.com/s/files/1/0039/8491/6589/files/top-pick-text.svg?v=1628190169"></div>',
    'vendorHtml': '<h4>{{itemVendorLabel}}</h4>',
    'quickViewHtml': '<a class="fancybox.ajax product-modal" rel="nofollow" href="{{itemUrl}}?view=quick">' + bcSfFilterConfig.label.quick_view + '</a>',
    'imageFlipHtml': '<div class="hidden"><img src="{{imageFlipUrl}}" alt="{{itemTitle}}" /></div>',

    // Grid Template
    'productGridItemHtml':  '<div id="prod-{{itemId}}" class="product {{itemGridWidthClass}} tablet-half mobile-half" data-alpha="{{itemTitle}}" data-price="{{itemPriceNumber}}">' +
  								'{{smartwishlist}}'+
                                '<div class="ci">' +
                                    '<a href="{{itemUrl}}" title="'+'{{itemTitle}}">' +
                                        '<div class="collection_badges">'+
                                          '{{itemNewLabel}}' +
                                          '{{itemSaleLabel}}' +
                                          '{{itemSoldoutLabel}}' +
                                          '{{itemBestLabel}}' +
                                          '{{itemtoppickLabel}}' +
                                        '</div>'+
                                        '<div class="reveal">' +
                                            '<img src="{{itemThumbUrl}}" alt="'+'{{itemTitle}}" />' +
                                            '{{itemImageFlip}}' +
                                        '</div>' +
                                    '</a>' +
                                '</div>' +

                                '<div class="product-info">' +
                                    '{{itemQuickView}}' +
                                '</div>' +
                                '<div class="product-sold-out-badges">' +
                                    '{{itemSoldoutLabel}}' +
                                '</div>' +
                                '<div class="product-details">' +
                                    '<a href="{{itemUrl}}">' +
                                        '<h3>{{itemTitle}}</h3>' +
                                        '{{itemVendor}}' +
                                    '</a>' +
                                    '<div class="price">{{itemPrice}}</div>' +
                                '</div>' +
                            '</div>'+
  							'{{extraHtml}}',

    // Pagination Template
    'previousHtml': '<a href="{{itemUrl}}"><</a>',
    'nextHtml': '<a href="{{itemUrl}}">></a>',
    'pageItemHtml': '<a href="{{itemUrl}}">{{itemTitle}}</a>',
    'pageItemSelectedHtml': '<span class="current">{{itemTitle}}</span>',
    'pageItemRemainHtml': '<span>{{itemTitle}}</span>',
    'paginateHtml': '<div id="pagination" class="desktop-12 mobile-3"><span class="count"></span>{{previous}}{{pageItems}}{{next}}</div>',

    // Sorting Template
    'sortingHtml': '<select id="sort-by" class="styled-select">{{sortingItems}}</select>',
};

// Build Product List
BCSfFilter.prototype.buildProductGridItem = function(data, index, totalProduct) {
    if(data.handle === 'kickstarter-backers-kingmaker-the-royal-re-launch' || data.handle === 'copy-of-kickstarter-backers-kingmaker-the-royal-re-launch'){
      return ''
    }
    /*** Prepare data ***/
    var images = data.images_info;
     // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)

    var firstVariant = data['variants'][0];
    if (getParam('variant') !== null && getParam('variant') != '') {
        var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
        if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
        for (var i = 0; i < data['variants'].length; i++) {
            if (data['variants'][i].available) {
                firstVariant = data['variants'][i];
                break;
            }
        }
    }
    /*** End Prepare data ***/
  
    // Get Template
    var itemHtml = bcSfFilterTemplate.productGridItemHtml;
  	var tags = data.tags;
    var collections_array = data.collections.map(function(collection) {
      return collection.handle;
    });
  	var tags_array = tags;

    // Add itemGridWidthClass
    var itemGridWidthClass = '';
    var productsPerRow = bcSfFilterConfig.custom.products_per_row;
    switch (productsPerRow) {
        case 4: itemGridWidthClass = buildItemGridClass('desktop-3', index, productsPerRow); break;
        case 3: itemGridWidthClass = buildItemGridClass('desktop-4', index, productsPerRow); break;
        default: break;
    }
    itemHtml = itemHtml.replace(/{{itemGridWidthClass}}/g, itemGridWidthClass);

    // Add Label
    var itemNewLabelHtml = '';
  	var itemBestLabelHtml = '';
    var itemSaleLabelHtml = '';
    var itemSoldoutLabelHtml = '';
  	var itemtoppickLabelHtml = '';
  
    if (!soldOut) {
        if (Shopify.shop === 'gibsonsgames.myshopify.com') {
            if (collections_array.indexOf('gibsons-new-releases') > -1) {
                itemNewLabelHtml = bcSfFilterTemplate.newLabelHtml;
            }
        } else {
            if (tags_array.includes('new') || tags_array.includes('New')) {
                itemNewLabelHtml = bcSfFilterTemplate.newLabelHtml;
            }
        }
        if(tags_array.includes('Best') || tags_array.includes('best')){
            itemBestLabelHtml = bcSfFilterTemplate.bestLabelHtml;
        }
        if(tags_array.includes('top-pick')){
            itemtoppickLabelHtml = bcSfFilterTemplate.toppickLabelHtml;
        }
        if (onSale) {
            itemSaleLabelHtml = bcSfFilterTemplate.saleLabelHtml;
        }
    } else {
        if (Shopify.shop === 'gibsonsgames.myshopify.com') {
            if (collections_array.indexOf('gibsons-new-releases') > -1) {
                itemNewLabelHtml = bcSfFilterTemplate.newLabelHtml;
            }
        } else {
            if (tags_array.includes('new') || tags_array.includes('New')) {
                itemNewLabelHtml = bcSfFilterTemplate.newLabelHtml;
            }
        }
      if(tags_array.includes('Best') || tags_array.includes('best')){
          itemBestLabelHtml = bcSfFilterTemplate.bestLabelHtml;
        }
      if(tags_array.includes('top-pick')){
          itemtoppickLabelHtml = bcSfFilterTemplate.toppickLabelHtml;
        }
       if (onSale) {
           // itemSaleLabelHtml = bcSfFilterTemplate.saleLabelHtml;
        }
       if(tags_array.includes('coming-soon')){
         
          //itemSoldoutLabelHtml = bcSfFilterTemplate.comingSoonLabelHtml;   
         
       }else{
         
         itemSoldoutLabelHtml = bcSfFilterTemplate.soldOutLabelHtml;
       }
    }
  
    itemHtml = itemHtml.replace(/{{itemNewLabel}}/g, itemNewLabelHtml);
  	itemHtml = itemHtml.replace(/{{itemBestLabel}}/g, itemBestLabelHtml);
  	itemHtml = itemHtml.replace(/{{itemtoppickLabel}}/g, itemtoppickLabelHtml);
    itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabelHtml);
    itemHtml = itemHtml.replace(/{{itemSoldoutLabel}}/g, itemSoldoutLabelHtml);
  	
  
  	var itemsmartHtml = '<span class="smartwishlist" data-product="'+data.id+'" data-variant="'+data.variants[0].id+'"></span>';
  	itemHtml = itemHtml.replace(/{{smartwishlist}}/g, itemsmartHtml);
  
  
    var DataSku = data.skus;
  
    console.log(DataSku);

  	itemHtml = itemHtml.replace(/{{trustpilot}}/g, '');
  
    // Add Vendor
    var itemVendorHtml = bcSfFilterConfig.custom.vendor_enable ? bcSfFilterTemplate.vendorHtml.replace(/{{itemVendorLabel}}/g, data.vendor) : '';
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

    // Add price
    var itemPriceHtml = '';
    if (onSale) {
        itemPriceHtml += '<div class="onsale">' + this.formatMoney(data.price_min, this.moneyFormat) + '</div>';
        itemPriceHtml += '<div class="was-listing">' + this.formatMoney(data.compare_at_price_min, this.moneyFormat) + '</div>'
    } else {
        itemPriceHtml += '<div class="prod-price">';
        if (priceVaries) {
            itemPriceHtml += bcSfFilterConfig.label.from_price + ' ' + this.formatMoney(data.price_min, this.moneyFormat) + ' - ' + this.formatMoney(data.price_max, this.moneyFormat);
        } else {
            itemPriceHtml += this.formatMoney(data.price_min, this.moneyFormat);
        }
        itemPriceHtml += '</div>';
    }
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    // Add Thumbnail
    var itemThumbUrl = images.length > 0 ? this.optimizeImage(images[0]['src'], '305x457') : bcSfFilterConfig.general.no_image_url;
    itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

    // Add Image Flip
    var itemImageFlipHtml = '';
    if (bcSfFilterConfig.custom.image_flip_enable && images.length > 1) { 
        itemImageFlipHtml = (bcSfFilterTemplate.imageFlipHtml).replace(/{{imageFlipUrl}}/g, this.optimizeImage(images[1]['src']));
    }
    itemHtml = itemHtml.replace(/{{itemImageFlip}}/g, itemImageFlipHtml);

    // Add Quick view
    var itemQuickViewHtml = bcSfFilterConfig.custom.quick_view_enable ? bcSfFilterTemplate.quickViewHtml : '';
    itemHtml = itemHtml.replace(/{{itemQuickView}}/g, itemQuickViewHtml);    

    // Add main attribute
  	var title = data.title;
  	var type = data.product_type;
  
  	
	title = title+'<br/>'+type;  
    itemHtml = itemHtml.replace(/{{itemPriceNumber}}/g, this.formatMoney(data.price_min, this.moneyFormat));
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
  var new_title = title.split('<br/>');
   new_title[0]  = new_title[0].replace('"', "''");
  new_title[1]  = new_title[1].replace('"', "''");
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, new_title[0]+' '+new_title[1]);
 
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));
  
  if(data.extra != undefined && data.extra != ''){
    var extraHtml = data.extra;
    itemHtml = itemHtml.replace(/{{extraHtml}}/g, extraHtml);
  }else{
    itemHtml = itemHtml.replace(/{{extraHtml}}/g, '');
  }

    return itemHtml;
}

function buildItemGridClass(itemClass, index, productsPerRow) {
    var temp = index < productsPerRow ? index : index % productsPerRow;
//     if (temp == 1) { itemClass += ' first'; }
//     else if (temp == 0) { itemClass += ' last'; };
    return itemClass;
}

// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
    // Get page info
    var currentPage = parseInt(this.queryParams.page);
    var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

    // If it has only one page, clear Pagination
    if (totalPage == 1) {
        jQ(this.selector.bottomPagination).html('');
        return false;
    }

    if (this.getSettingValue('general.paginationType') == 'default') {
        var paginationHtml = bcSfFilterTemplate.paginateHtml;

        // Build wrapper
        paginationHtml = paginationHtml.replace(/{{paginateWrapperClass}}/g, 'twelve');

        // Build Previous
        var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousHtml : '';
        previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage -1));
        paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

        // Build Next
        var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextHtml : '';
        nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
        paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

        // Create page items array
        var beforeCurrentPageArr = [];
        for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
            beforeCurrentPageArr.unshift(iBefore);
        }
        if (currentPage - 4 > 0) {
            beforeCurrentPageArr.unshift('...');
        }
        if (currentPage - 4 >= 0) {
            beforeCurrentPageArr.unshift(1);
        }
        beforeCurrentPageArr.push(currentPage);

        var afterCurrentPageArr = [];
        for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
            afterCurrentPageArr.push(iAfter);
        }
        if (currentPage + 3 < totalPage) {
            afterCurrentPageArr.push('...');
        }
        if (currentPage + 3 <= totalPage) {
            afterCurrentPageArr.push(totalPage);
        }

        // Build page items
        var pageItemsHtml = '';
        var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
        for (var iPage = 0; iPage < pageArr.length; iPage++) {
            if (pageArr[iPage] == '...') {
                pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
            } else {
                pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
            }
            pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
            pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
        }
        paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

        jQ(this.selector.bottomPagination).html(paginationHtml);
    }
};

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
    if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
        jQ(this.selector.topSorting).html('');

        var sortingArr = this.getSortingList();
        if (sortingArr) {
            // Build content 
            var sortingItemsHtml = '';
            for (var k in sortingArr) {
                sortingItemsHtml += '<option value="' + k +'">' + sortingArr[k] + '</option>';
            }
            var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
            jQ(this.selector.topSorting).html(html);

            // Set current value
            jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
        }
    }
};

// Build Breadcrumb
BCSfFilter.prototype.buildBreadcrumb = function(colData, apiData) {
    if (typeof colData !== 'undefined' && colData.hasOwnProperty('collection')) {
        var colInfo = colData.collection;
        var breadcrumbHtml = '<a href="/" class="homepage-link" title="' + bcSfFilterConfig.label.breadcrumb_home + '">' + bcSfFilterConfig.label.breadcrumb_home + '</a>';
        breadcrumbHtml += '<span class="separator">&raquo;</span>';
        if (bcSfFilterConfig.general.current_tags !== null) {
            var currentTags = bcSfFilterConfig.general.current_tags;
            breadcrumbHtml += ' <a href="/collections/' + colInfo.handle + '">' + colInfo.title + '</a>';
            breadcrumbHtml += ' <span class="separator">&raquo;</span>'
            breadcrumbHtml += ' <span class="page-title">' + currentTags[0] + '</span>';
        } else {
            breadcrumbHtml += ' <span class="page-title">' + colInfo.title + '</span>';
        }
        jQ('#breadcrumb').html(breadcrumbHtml);
    }
};

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function(data) {
  if (typeof ReloadSmartWishlist !== "undefined" && $.isFunction(ReloadSmartWishlist)) ReloadSmartWishlist();
};

// Capitalize label of filter option
BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {
    var from = this.queryParams.page == 1 ? this.queryParams.page : (this.queryParams.page - 1) * this.queryParams.limit + 1;
    var to = this.queryParams.page * this.queryParams.limit;
    jQ(this.selector.bottomPagination).find('.count').html(bcSfFilterConfig.label.showing_items + ' ' + from + '-' + to + ' / ' + data.total_product);
};

// Build Default layout
function buildDefaultLink(a,b){var c=window.location.href.split("?")[0];return c+="?"+a+"="+b}BCSfFilter.prototype.buildDefaultElements=function(a){if(bcSfFilterConfig.general.hasOwnProperty("collection_count")&&jQ("#bc-sf-filter-bottom-pagination").length>0){var b=bcSfFilterConfig.general.collection_count,c=parseInt(this.queryParams.page),d=Math.ceil(b/this.queryParams.limit);if(1==d)return jQ(this.selector.pagination).html(""),!1;if("default"==this.getSettingValue("general.paginationType")){var e=bcSfFilterTemplate.paginateHtml,f="";f=c>1?bcSfFilterTemplate.hasOwnProperty("previousActiveHtml")?bcSfFilterTemplate.previousActiveHtml:bcSfFilterTemplate.previousHtml:bcSfFilterTemplate.hasOwnProperty("previousDisabledHtml")?bcSfFilterTemplate.previousDisabledHtml:"",f=f.replace(/{{itemUrl}}/g,buildDefaultLink("page",c-1)),e=e.replace(/{{previous}}/g,f);var g="";g=c<d?bcSfFilterTemplate.hasOwnProperty("nextActiveHtml")?bcSfFilterTemplate.nextActiveHtml:bcSfFilterTemplate.nextHtml:bcSfFilterTemplate.hasOwnProperty("nextDisabledHtml")?bcSfFilterTemplate.nextDisabledHtml:"",g=g.replace(/{{itemUrl}}/g,buildDefaultLink("page",c+1)),e=e.replace(/{{next}}/g,g);for(var h=[],i=c-1;i>c-3&&i>0;i--)h.unshift(i);c-4>0&&h.unshift("..."),c-4>=0&&h.unshift(1),h.push(c);for(var j=[],k=c+1;k<c+3&&k<=d;k++)j.push(k);c+3<d&&j.push("..."),c+3<=d&&j.push(d);for(var l="",m=h.concat(j),n=0;n<m.length;n++)"..."==m[n]?l+=bcSfFilterTemplate.pageItemRemainHtml:l+=m[n]==c?bcSfFilterTemplate.pageItemSelectedHtml:bcSfFilterTemplate.pageItemHtml,l=l.replace(/{{itemTitle}}/g,m[n]),l=l.replace(/{{itemUrl}}/g,buildDefaultLink("page",m[n]));e=e.replace(/{{pageItems}}/g,l),jQ(this.selector.pagination).html(e)}}if(bcSfFilterTemplate.hasOwnProperty("sortingHtml")&&jQ(this.selector.topSorting).length>0){jQ(this.selector.topSorting).html("");var o=this.getSortingList();if(o){var p="";for(var q in o)p+='<option value="'+q+'">'+o[q]+"</option>";var r=bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g,p);jQ(this.selector.topSorting).html(r);var s=void 0!==this.queryParams.sort_by?this.queryParams.sort_by:this.defaultSorting;jQ(this.selector.topSorting+" select").val(s),jQ(this.selector.topSorting+" select").change(function(a){window.location.href=buildDefaultLink("sort_by",jQ(this).val())})}}};

function customizeJsonProductData(data) { for (var i = 0; i < data.variants.length; i++) { var variant = data.variants[i]; var featureImage = data.images.filter(function (e) { return e.src == variant.image; }); if (featureImage.length > 0) { variant.featured_image = { id: featureImage[0]["id"], product_id: data.id, position: featureImage[0]["position"], created_at: "", updated_at: "", alt: null, width: featureImage[0]["width"], height: featureImage[0]["height"], src: featureImage[0]["src"], variant_ids: [variant.id], }; } else { variant.featured_image = ""; } } var self = bcsffilter; var itemJson = { id: data.id, title: data.title, handle: data.handle, vendor: data.vendor, variants: data.variants, url: self.buildProductItemUrl(data), options_with_values: data.options_with_values, images: data.images, images_info: data.images_info, available: data.available, price_min: data.price_min, price_max: data.price_max, compare_at_price_min: data.compare_at_price_min, compare_at_price_max: data.compare_at_price_max, }; return itemJson; }

BCSfFilter.prototype.prepareProductData = function (data) {
  var self = this;
  var countData = data.length;
  for (var k = 0; k < countData; k++) {
    data[k]["images"] = data[k]["images_info"];
    if (data[k]["images"].length > 0) {
      data[k]["featured_image"] = data[k]["images"][0];
    } else {
      data[k]["featured_image"] = {
        src: bcSfFilterConfig.general.no_image_url,
        width: "",
        height: "",
        aspect_ratio: 0,
      };
    }
    data[k]["url"] = "/products/" + data[k].handle;
    var optionsArr = [];
    var countOptionsWithValues = data[k]["options_with_values"].length;
    for (var i = 0; i < countOptionsWithValues; i++) {
      optionsArr.push(data[k]["options_with_values"][i]["name"]);
    }
    data[k]["options"] = optionsArr;
    var firstVariant = data[k]["variants"][0];
    var isRoundedPrice = true;
    if (
      firstVariant.hasOwnProperty("fulfillment_service") &&
      firstVariant.fulfillment_service == "gift_card"
    ) {
      isRoundedPrice = false;
    }
    var currenciesSeting = bcSfFilterMainConfig.general.currencies;
    if (typeof currenciesSeting != "undefined" && currenciesSeting.length > 1) {
      var currentCurrency = bcSfFilterMainConfig.general.current_currency
        .toLowerCase()
        .trim();
      var prices = [
        "price_min",
        "price_max",
        "compare_at_price_min",
        "compare_at_price_max",
      ];
      prices.forEach(function(priceKey) {
        var currentPriceKey = priceKey + "_" + currentCurrency;
        if (typeof data[k][currentPriceKey] !== "undefined") {
          data[k][priceKey] = data[k][currentPriceKey];
        }
      });
    }
    (data[k]["price_min"] *= 100), (data[k]["price_max"] *= 100);
    if (data[k]["compare_at_price_min"] != null) {
      data[k]["compare_at_price_min"] *= 100;
    }
    if (data[k]["compare_at_price_max"] != null) {
      data[k]["compare_at_price_max"] *= 100;
    }
    data[k]["price"] = data[k]["price_min"];
    data[k]["compare_at_price"] = data[k]["compare_at_price_min"];
    data[k]["price_varies"] = data[k]["price_min"] != data[k]["price_max"];
    if (getParam("variant") !== null && getParam("variant") != "") {
      var paramVariant = data[k]["variants"].filter(function (e) {
        return e.id == getParam("variant");
      });
      if (typeof paramVariant[0] !== "undefined")
        firstVariant = paramVariant[0];
    } else {
      var countVariants = data[k]["variants"].length;
      for (var i = 0; i < countVariants; i++) {
        if (data[k]["variants"][i].available) {
          firstVariant = data[k]["variants"][i];
          break;
        }
      }
    }
    data[k]["selected_or_first_available_variant"] = firstVariant;
    var countVariants = data[k]["variants"].length;
    for (var i = 0; i < countVariants; i++) {
      var variantOptionArr = [];
      var count = 1;
      var variant = data[k]["variants"][i];
      var variantOptions = variant["merged_options"];
      if (Array.isArray(variantOptions)) {
        var countVariantOptions = variantOptions.length;
        for (var j = 0; j < countVariantOptions; j++) {
          var temp = variantOptions[j].split(":");
          data[k]["variants"][i]["option" + (parseInt(j) + 1)] = temp[1];
          data[k]["variants"][i]["option_" + temp[0]] = temp[1];
          variantOptionArr.push(temp[1]);
        }
        data[k]["variants"][i]["options"] = variantOptionArr;
      }
      if (data[k]["variants"][i]["compare_at_price"] != null) {
        var variantCompareAtPrice = parseFloat(
          data[k]["variants"][i]["compare_at_price"]
        );
        if (typeof self.convertPriceBasedOnActiveCurrency !== "undefined") {
          variantCompareAtPrice = self.convertPriceBasedOnActiveCurrency(
            variantCompareAtPrice,
            isRoundedPrice
          );
        }
        data[k]["variants"][i]["compare_at_price"] =
          variantCompareAtPrice * 100;
      }
      var variantPrice = parseFloat(data[k]["variants"][i]["price"]);
      if (typeof self.convertPriceBasedOnActiveCurrency !== "undefined") {
        variantPrice = self.convertPriceBasedOnActiveCurrency(
          variantPrice,
          isRoundedPrice
        );
      }
      data[k]["variants"][i]["price"] = variantPrice * 100;
    }
    data[k]["description"] = data[k]["content"] = data[k]["body_html"];
    if (
      data[k].hasOwnProperty("original_tags") &&
      data[k]["original_tags"].length > 0
    ) {
      data[k]["tags"] = data[k]["original_tags"].slice(0);
    }
    data[k]["json"] = customizeJsonProductData(data[k]);
  }
  return data;
};


// Fix image url issue of swatch option
function getFilePath(fileName, ext, version) {
    var self = bcsffilter;
    var ext = typeof ext !== 'undefined' ? ext : 'png';
    var version = typeof version !== 'undefined' ? version : '1';
    var prIndex = self.fileUrl.lastIndexOf('?');
    if (prIndex > 0) {
        var filePath = self.fileUrl.substring(0, prIndex);
    } else {
        var filePath = self.fileUrl;
    }
    filePath += fileName + '.' + ext + '?v=' + version;
    return filePath;
}

BCSfFilter.prototype.getFilterData=function(eventType,errorCount){function BCSend(eventType,errorCount){var self=bcsffilter;var errorCount=typeof errorCount!=="undefined"?errorCount:0;self.showLoading();if(typeof self.buildPlaceholderProductList=="function"){self.buildPlaceholderProductList(eventType)}self.beforeGetFilterData(eventType);self.prepareRequestParams(eventType);self.queryParams["callback"]="BCSfFilterCallback";self.queryParams["event_type"]=eventType;var url=self.isSearchPage()?self.getApiUrl("search"):self.getApiUrl("filter");var script=document.createElement("script");script.type="text/javascript";var timestamp=(new Date).getTime();script.src=url+"?t="+timestamp+"&"+jQ.param(self.queryParams);script.id="bc-sf-filter-script";script.async=true;var resendAPITimer,resendAPIDuration;resendAPIDuration=2e3;script.addEventListener("error",function(e){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}if(errorCount<3){errorCount++;if(resendAPITimer){clearTimeout(resendAPITimer)}resendAPITimer=setTimeout(self.getFilterData("resend",errorCount),resendAPIDuration)}else{self.buildDefaultElements(eventType)}});document.getElementsByTagName("head")[0].appendChild(script);script.onload=function(){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}}}this.requestFilter(BCSend,eventType,errorCount)};BCSfFilter.prototype.requestFilter=function(sendFunc,eventType,errorCount){sendFunc(eventType,errorCount)};


/* start-boost-2.4.8 */
BCSfFilter.prototype.buildFilterOptionItem=function(html,iLabel,iValue,fOType,fOId,fOLabel,fODisplayType,fOSelectType,fOItemValue,fOData){var keepValuesStatic=fOData.hasOwnProperty("keepValuesStatic")?fOData.keepValuesStatic:false;if(fOType=="review_ratings"&&this.getSettingValue("general.ratingSelectionStyle")=="text"){var title=this.getReviewRatingsLabel(fOItemValue.from)}else{var title=this.customizeFilterOptionLabel(iLabel,fOData.prefix,fOType)}if(keepValuesStatic===true)var productNumber=null;else var productNumber=fOItemValue.hasOwnProperty("doc_count")?fOItemValue.doc_count:0;html=html.replace(/{{itemLabel}}/g,this.buildFilterOptionLabel(iLabel,productNumber,fOData));html=html.replace(/{{itemLink}}/g,this.buildFilterOptionLink(fOId,iValue,fOType,fODisplayType,fOSelectType,keepValuesStatic));html=html.replace(/{{itemValue}}/g,encodeURIParamValue(iValue));html=html.replace(/{{itemTitle}}/g,title);html=html.replace(/{{itemFunc}}/g,"onInteractWithFilterOptionValue(event, this, '"+fOType+"', '"+fODisplayType+"', '"+fOSelectType+"', '"+keepValuesStatic+"')");html=this.checkFilterOptionSelected(fOId,iValue,fOType,fODisplayType)?html.replace(/{{itemSelected}}/g,"selected"):html.replace(/{{itemSelected}}/g,"");var htmlElement=jQ(html);htmlElement.children().attr({"data-id":fOId,"data-value":encodeURIParamValue(iValue),"data-parent-label":fOLabel,"data-title":title,"data-count":productNumber});if(fOType!="collection"){htmlElement.children().attr("rel","nofollow")}if(fOType=="collection")htmlElement.children().attr("data-collection-scope",fOItemValue.key);return jQ(htmlElement)[0].outerHTML};
/* end-boost-2.4.8 */
/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */

const observeProducts = () => {
  const productLoop = document.querySelector(bcSfFilterSettings.selector.products);
  if (!productLoop) return;

  const productObserver = new MutationObserver((mutations, observer) => {
    const products = productLoop.querySelectorAll('.product');
    if (products.length > 0) {
      observer.disconnect();
      observeBadges(products);
    }
  });

  productObserver.observe(productLoop, { childList: true, subtree: true });
};

const observeBadges = (products) => {
  products.forEach(product => {
    const badgeContainer = product.querySelector('.collection_badges');
    const revealContainer = product.querySelector('.reveal');
    if (!badgeContainer || !revealContainer) return;

    const badgeObserver = new MutationObserver((mutations, observer) => {
      const quickView = badgeContainer.querySelector('.satcb_quick_view');
      if (quickView) {
        revealContainer.appendChild(quickView);
        observer.disconnect();
      }
    });

    badgeObserver.observe(badgeContainer, { childList: true, subtree: true });
  });
};

observeProducts();
